import { GLASS_CLASSES } from '../../../modules/design-system';

export interface MyPacksPillProps {
  onClick?: () => void;
  label?: string;
}

/**
 * Modern MyPacks pill — Figma `543:6354` (desktop) / `425:1048` (mobile).
 *
 * Same glass surface on every breakpoint (no D-shape mobile variant). The
 * only thing that flexes is the size: h-36/13px on < 600px, h-44/15px on
 * ≥ 600px — matching the rest of the modern pill system.
 */
export function MyPacksPill({ onClick, label = 'My Packs' }: MyPacksPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={
        GLASS_CLASSES +
        ' inline-flex items-center cursor-pointer whitespace-nowrap text-white font-semibold ' +
        'h-9 px-3 text-[13px] tracking-[-0.1px] ' +
        '@[600px]:h-11 @[600px]:px-5 @[600px]:text-[15px] @[600px]:tracking-[-0.3px] ' +
        'transition-opacity hover:opacity-90'
      }
    >
      {label}
    </button>
  );
}
